import { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { MobileDatePicker } from "../../../components/MobilePicker/MobileDatePicker";

export const DatePickerInput = ({ value, onChange, title, placeholder = "請選擇" }: any) => {
  const [visible, setVisible] = useState(false);

  const displayValue = value ? (dayjs.isDayjs(value) ? value.format("YYYY-MM-DD") : value) : "";

  return (
    <>
      <div
        onClick={() => setVisible(true)}
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
          padding: "4px 11px",
          height: 40,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          background: "#fff",
          width: "100%",
        }}
      >
        <span style={{ color: displayValue ? "#333" : "#bfbfbf", fontSize: 14 }}>{displayValue || placeholder}</span>
        <DownOutlined style={{ color: "#bfbfbf", fontSize: 12 }} />
      </div>
      <MobileDatePicker
        visible={visible}
        onClose={() => setVisible(false)}
        title={title}
        value={value}
        onChange={(dateString) => {
          onChange?.(dateString || null);
        }}
      />
    </>
  );
};
